<div class="actions-content" *ngIf="value">
    <shared-accesscontrol-transitions [accessControlId]="value.accessControlId"
        [phaseId]="value.phaseId"></shared-accesscontrol-transitions>
</div>